/// <reference path="../angular.min.js" />
/// <reference path="newsletterform.controller.js" />

MCApp.factory("NewsletterFormServices", function ($http, $log) {
    return {
        SubmitNewsletterForm: function (data) {
            return $http({
                method: "POST",
                url: "/Umbraco/Api/NewsletterFormApi/SubmitNewsletterForm",
                data: data
            });
        }
    }
})